export const transition = {
    duration: .75,
    ease: [.56, .03, .12, 1.04],
};

export const tabTransition = {
    duration: 0.25,
    ease: [.56, .03, .12, 1.04],
}

export const containerVariants = {
    hidden: {
        y: '100%'
    },
    visible: {
        y: 0,
        transition: {
            ...transition,
            delay: .25
        }
    },
    exit: {
        y: '100%',
    }
};

export const overlayVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1
    },
    exit: {
        opacity: 0,
        transition: {
            ...transition,
            delay: .25
        }
    }
};

export const contentVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            ...transition,
            delay: .5
        }
    },
}

export const tabVariants = {
    inactiveLeft: {
        y: '.2rem',
        boxShadow: 'inset -1px -1px 3px #000',
        backgroundColor: '#ededed',
        color: '#444'
    },
    inactiveRight: {
        y: '.2rem',
        boxShadow: 'inset 1px -1px 3px #000',
        backgroundColor: '#ededed',
        color: '#444'
    },
    active: {
        y: '.1rem',
        backgroundColor: '#fafafa',
        color: '#364957'
    },
    hoverLeft: {
        y: '.15rem',
        boxShadow: 'inset -1px -1px 2px #000',
        backgroundColor: '#efefef',
    },
    hoverRight: {
        y: '.15rem',
        boxShadow: 'inset 1px -1px 2px #000',
        backgroundColor: '#efefef',
    }
}

export const qrVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
    },
    exit: {
        opacity: 0,
    }
}

export const closeVariants = {
    hidden: {
        opacity: 0,
        x: '150%'
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            ...transition,
            delay: .75
        }
    },
    exit: {
        opacity: 0,
        x: '150%'
    }
}